import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NationalHolidayDetailComponent } from './national-holiday-detail.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { nationalHolidayDetailRoutes } from './national-holiday-detail.routing';
import { RouterModule } from '@angular/router';
import { TrendencyTranslationsChildModule } from '@trendency/translations';
import { NationalHolidayDetailService } from './services/national-holiday-detail.service';
import { NationalHolidayDetailResolver } from './resolvers/national-holiday-detail.resolver';

@NgModule({
  declarations: [NationalHolidayDetailComponent],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(nationalHolidayDetailRoutes),
    TrendencyTranslationsChildModule.forChild(nationalHolidayDetailRoutes),
    SharedModule,
  ],
  providers: [NationalHolidayDetailResolver, NationalHolidayDetailService],
})
export class NationalHolidayDetailModule {}
